<template>
  <div class="warpper">
    <div class="head-swiper" ref="swiperRef">
      <menuSwiper></menuSwiper>
    </div>
    <list :groupId="id"></list>
  </div>
</template>

<script>
import menuSwiper from './swiper'
import list from './components/list.vue'
// import { getTop } from 'api'
export default {
  data () {
    return {
      id: '',
      groupId:'groupId'
    }
  },
  created () {
    this.id = this.$route.params.id
  },
  methods: {
    switchSwiper(index) {
      if(index === 0){
        this.id = ''
      }else{
        this.id = index
      }
    }
  },
  components: {
    list,
    menuSwiper
  }
}
</script>

<style lang="less" scoped>
.warpper {
  height: 100vh;
}
</style>
